import RequiredReactSelect from "@components/FormsV2/RequiredReactSelect/RequiredReactSelect";
import { ITEM_TYPES, type ItemOption, type ItemType } from "./types";
import "./style.css";

export interface ItemPickerProps {
  itemType: ItemType;
  itemId: string;
  services: ItemOption[];
  governances: ItemOption[];
  products: ItemOption[];
  onItemTypeChange: (t: ItemType) => void;
  onItemIdChange: (id: string) => void;
}

export const ItemPicker = ({
  itemType,
  itemId,
  services,
  governances,
  products,
  onItemTypeChange,
  onItemIdChange,
}: ItemPickerProps): JSX.Element => {
  const items =
    itemType === "Task"
      ? services
      : itemType === "Governance"
      ? governances
      : products;
  const itemOptions = items.map((o) => ({ value: o.id, label: o.label }));

  return (
    <div className="row">
      <div className="col-sm-4">
        <RequiredReactSelect
          label="Item Type"
          value={ITEM_TYPES.find((o) => o.value === itemType)}
          onChange={(opt: any) =>
            onItemTypeChange((opt?.value ?? "Task") as ItemType)
          }
          options={ITEM_TYPES}
          placeholder="Select…"
          required
        />
      </div>
      <div className="col-sm-8">
        <RequiredReactSelect
          label="Item"
          value={itemOptions.find((o) => o.value === itemId)}
          onChange={(opt: any) => onItemIdChange(opt?.value ?? "")}
          options={itemOptions}
          placeholder="Choose an item…"
          required
        />
      </div>
    </div>
  );
};

export default ItemPicker;
